export function calculateAmountInVatWithVatShift(amountInVat: number, vatPercentage: number, isShiftVat: boolean) {
	if (isShiftVat === false) {
		return amountInVat;
	} else {
		return amountInVat / (1 + vatPercentage / 100);
	}
}
